import { IState } from '../../../store';

export const selectIsArchived = (state: IState): boolean => {
  return Boolean(state.offerData.offer.flags?.isArchived);
};
